import { useEffect } from 'react'
import { useLocation } from 'react-router'
import queryString from 'query-string'
import Base from '../../pages/Base'
import AppLauncher from '../../components/AppLauncher'
import redirect from '../../utils/redirect'

const getLaunchUrl = search => {
  const params = queryString.parse(search)
  const redirectUrl = params.next
  if (!redirectUrl) return ''
  delete params.next
  if (redirectUrl.includes('?')) {
    return redirectUrl + '&' + queryString.stringify(params)
  }
  return redirectUrl + '?' + queryString.stringify(params)
}

export const AppLauncherPage = props => {
  const {
    metadata: { client },
    brandingSettings,
    showGoogleFooterLink
  } = props
  const { search } = useLocation()
  const launchUrl = getLaunchUrl(search)

  useEffect(() => {
    if (launchUrl) redirect(launchUrl)
  }, [launchUrl])

  return (
    <Base
      brandingSettings={brandingSettings}
      showGoogleFooterLink={showGoogleFooterLink}
    >
      <AppLauncher name={client.name} launchUrl={launchUrl} />
    </Base>
  )
}

export default AppLauncherPage
